export default {
  methods: {
    calcularDiferenciaEnDias(fechaInicio, fechaTermino) {
      const nuevaFechaInicio = new Date(`${fechaInicio}T00:00:00Z`);
      const nuevaFechaTermino = new Date(`${fechaTermino}T00:00:00Z`);
      // Calcular
      const diferenciaMiliSegundos = Math.abs(nuevaFechaTermino - nuevaFechaInicio);
      const diferenciaDias = Math.ceil(diferenciaMiliSegundos / (1000 * 60 * 60 * 24));

      return diferenciaDias + 1;
    },
    sumarMontoAcumulado(programadoAnteriror) {
      if (!programadoAnteriror) return 0;
      return this.$ObjSumar(programadoAnteriror, 'monto');
    },
    getPrograma(programas) {
      if (!programas || programas.length <= 0) return [];

      // Destructurar el primer progama
      const [{ programa }] = programas;

      // Monto del programa
      const montoDelPrograma = this.$ObjSumar(programa, 'monto');

      // Suma de los montos
      let suma = 0;

      return (
        programa
          // Ordernar el programa por fecha de termino
          .sort(
            (a, b) => new Date(`${a.fechaTermino}T00:00:00Z`) - new Date(`${b.fechaTermino}T00:00:00Z`),
          )
          // Calcular el porcentaje de avance
          .map((item) => {
            // Sumar el monto anterior con el monto actual
            suma += item.monto;

            // Regresar el objeto con el calculo de avance
            return {
              ...item,
              // Calcular porcentaje de avance programado
              avance: this.$numberRound((suma / montoDelPrograma) * 100),
            };
          })
      );
    },
    mixCalcularAvanceProgramado(fecha, contrato) {
      let total = 0;

      if (!fecha || !contrato.programas || contrato.programas.length <= 0) {
        return {
          porcentaje: 0,
          importe: 0,
          diasTranscuridos: 0,
        };
      }
      // Fecha del avance
      const alFecha = new Date(`${fecha}T00:00:00Z`);

      // Seleccionar el primer programa del listado de programas de obra del contrato
      const programaUno = this.getPrograma(contrato.programas);
      const montoDelPrograma = this.$ObjSumar(programaUno, 'monto');

      const diasTranscuridos = this.calcularDiferenciaEnDias(programaUno[0].fechaInicio, fecha);

      // Acumulado del programa
      const programaAcumulado = programaUno.filter(
        (programa) => new Date(programa.fechaTermino) <= alFecha,
      );

      // Importe acumulado
      const importeAcumulado = this.sumarMontoAcumulado(programaAcumulado);

      // Programa actual
      const programadoActual = programaUno.filter(
        (programa) => alFecha >= new Date(`${programa.fechaInicio}T00:00:00Z`)
          && alFecha < new Date(`${programa.fechaTermino}T00:00:00Z`),
      );

      // Si no hay programado actual, entonces regresas el 100%
      // y, el importe acumulado actual
      if (programadoActual.length <= 0) {
        total = importeAcumulado;

        return {
          porcentaje: this.$obtenerImporteDosDecimales((total / montoDelPrograma) * 100),
          importe: this.$obtenerImporteDosDecimales(total),
          diasTranscuridos,
        };
      }

      // Cantidad de dias ejecutados a la fecha
      const diasEjecutados = this.calcularDiferenciaEnDias(programadoActual[0].fechaInicio, fecha);

      // Cantidad de dias del periodo
      const diasDelPeriodo = this.calcularDiferenciaEnDias(
        programadoActual[0].fechaInicio,
        programadoActual[0].fechaTermino,
      );

      // Importe diario
      const importeDiario = programadoActual[0].monto / diasDelPeriodo;

      // Importe ejecutado del periodo
      const importeEjecutadoDelPeriodo = importeDiario * diasEjecutados;

      // Importe ejecutado
      const importeEjecutado = importeAcumulado + importeEjecutadoDelPeriodo;

      total = importeEjecutado;

      // Porcentaje de avace
      const porcentajeProgramado = (total / montoDelPrograma) * 100;

      // Regresar el porcentaje de avance programado y el importe ejecutado a la fecha
      return {
        porcentaje: this.$obtenerImporteDosDecimales(porcentajeProgramado),
        importe: this.$obtenerImporteDosDecimales(total),
        diasTranscuridos,
      };
    },
  },
};
